import { createAction, props } from '@ngrx/store';
import { ProvinceModel } from '@roi/common/models/province.model';

export const loadProvinces = createAction('[Geo] Load Provinces');

export const loadProvincesSuccess = createAction(
  '[Geo] Load Provinces Success',
  props<{ provinces: ProvinceModel[] }>()
);

export const loadProvincesFailure = createAction(
  '[Geo] Load Provinces Failure',
  props<{ error: any }>()
);
